import React from 'react';
import { BaseModuleProps, ITestimonialBlock } from '../types';
import { MultipleTestimonial } from './MultipleTestimonials';
import { SingleTestimonial } from './SingleTestimonial';
import './testimonial.scss';

interface ITestimonialProps {
    moduleClass: string;
    headline: string;
    testimonialGroup: Array<ITestimonialBlock>;
}

const Testimonial: React.FC<ITestimonialProps & BaseModuleProps> = ({
    headline,
    testimonialGroup,
    variant,
}) => {
    if (testimonialGroup.length === 1) {
        return (
            <SingleTestimonial
                testimonial={testimonialGroup[0]}
                variant={variant}
            />
        );
    } else {
        return (
            <MultipleTestimonial
                headline={headline}
                testimonials={testimonialGroup}
                variant={variant}
            />
        );
    }
};

export default Testimonial;
